import { withRouter } from 'react-router-dom'
import React from 'react'
import { TableVirtualized } from '../root/components/common/table-virtualized/table'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { getFormattedDate } from '../../utils'

const EscalationLevelsBillingTableComponent = ({ data }) => {
    const { locale } = useSelector(state => state.main)

    const columns = [
        {
            key: 'email',
            label: locale.common.email,
            sortable: false,
            width: 1.5,
            dataType: 'string',
            render: ({ rowData, cellData }) => {
                return (
                    <Typography noWrap variant="inherit">
                        {rowData.email}
                    </Typography>
                )
            }
        },
        {
            key: 'removed_at',
            label: locale.billing.removedAt,
            sortable: false,
            dataType: 'date',
            width: 1,
            render: ({ rowData }) =>
                rowData.removed_at ? (
                    <div>{getFormattedDate(rowData.removed_at)}</div>
                ) : (
                    '--'
                )
        }
    ]

    return <TableVirtualized data={data} columns={columns} />
}

const EscalationLevelsBillingTable = withRouter(
    EscalationLevelsBillingTableComponent
)
export { EscalationLevelsBillingTable }
